import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import BootSplash from './components/BootSplash'
import { registerServiceWorker } from './boot/registerServiceWorker'
import { useDelayedFlag } from './boot/useDelayedFlag'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import './index.css'

function BootGate() {
  const { loading } = useAuth()
  const showIdleHint = useDelayedFlag(loading)

  if (loading) {
    return <BootSplash showIdleHint={showIdleHint} />
  }

  return <App />
}

registerServiceWorker()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <BootGate />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
